import React from 'react'
import moment from 'moment'
import get from 'lodash/get'
import { DATE_FORMAT, TIME_FORMAT } from 'config/consts'
import { numberColumn } from 'components/DataTable'

export const loyaltycardList = t => [
	{
		Header: <span className='sort-icons'>{t('common.fields.code')}</span>,
		accessor: 'id',
		width: 80
	}, {
		Header: <span className='sort-icons'>{t('loyalty_card_section.fields.card_name')}</span>,
		accessor: 'name'
	}, {
		Header: <span className='sort-icons'>{t('loyalty_card_section.strings.balance')}</span>,
		accessor: 'balance',
		width: 80,
		...numberColumn()
	}, {
		Header: t('loyalty_card_section.fields.points'),
		accessor: 'points',
		width: 90,
		style: {
			justifyContent: 'flex-end'
		},
		...numberColumn({ toFixed: 0, alignHeaderLeft: true })
	}, {
		// this is for query search
		accessor: 'barCode',
		show: false
	}, {
		// this is for query search
		accessor: 'phoneNumber',
		show: false
	}
]


const getCellVal = path => ({ original }) => get(original, path, '')
export const loyaltycardTransactions = t => [
	{
		Header: t('common.fields.from_date'),
		Cell: ({ original: { dateTime } }) => moment(dateTime).utc().format(DATE_FORMAT)
	}, {
		Header: t('common.fields.to_date'),
		Cell: ({ original: { dateTime } }) => moment(dateTime).utc().format(TIME_FORMAT)
	}, {
		Header: t('common.fields.name'),
		accessor: 'name'
	}, {
		Header: t('loyalty_card_section.strings.group'),
		Cell: getCellVal('group.name'),
		show: false
	}, {
		Header: t('common.fields.cash_register'),
		Cell: getCellVal('cashRegister.name')
	}, {
		Header: t('loyalty_card_section.strings.bill_number'),
		accessor: 'billNumber',
		Cell: ({ original: { billNumber } }) => billNumber || ''
	}, {
		Header: t('loyalty_card_section.strings.user_name'),
		accessor: 'userName'
	}, {
		Header: t('loyalty_card_section.strings.credit'),
		accessor: 'increase',
		...numberColumn()
	}, {
		Header: t('loyalty_card_section.strings.charge'),
		accessor: 'decrease',
		show: false,
		...numberColumn()
	}, {
		Header: t('loyalty_card_section.fields.balance'),
		accessor: 'balance',
		show: false,
		...numberColumn()
	}, {
		Header: t('loyalty_card_section.fields.points'),
		accessor: 'points',
		show: false,
		...numberColumn({ toFixed: 0 })
	}, {
		Header: t('loyalty_card_section.strings.points_balance'),
		accessor: 'pointsTotal',
		show: false,
		...numberColumn()
	}, {
		Header: t('loyalty_card_section.strings.booking_mode'),
		accessor: 'mode',
		show: false
	}, {
		Header: `${t('common.fields.cash_register')} ${t('common.fields.date')}`,
		Cell: ({ original: { transactionDate } }) => moment(transactionDate).utc().format(DATE_FORMAT),
		show: false
	}, {
		Header: `${t('common.fields.cash_register')} ${t('common.fields.time')}`,
		Cell: ({ original: { transactionDate } }) => moment(transactionDate).utc().format(TIME_FORMAT),
		show: false
	}, {
		accessor: 'isCancelled',
		show: false,
		hidden: true
	}
]

export const loyaltycardHistory = [
	{
		Header: 'Datum',
		accessor: 'date'
	}, {
		Header: 'Zeit',
		accessor: 'time'
	}, {
		Header: 'Operation',
		accessor: 'action',
		width: 200
	}, {
		Header: 'Benutzername',
		accessor: 'username',
		width: 150
	}, {
		Header: 'Art',
		accessor: 'type',
		width: 200
	}
]

export const seriesCards = t => [
	{
		Header: t('common.fields.code'),
		accessor: 'id',
		width: 100
	}, {
		Header: t('loyalty_card_section.fields.card_name'),
		accessor: 'name'
	}
]
